<vp-select-shell
	[clearable]="true"
	[editableSearchTerm]="true"
	[filterOptions]="false"
	[inputId]="inputId()"
	[isOpen]="panelOpen()"
	[label]="label()"
	[loading]="loading()"
	[loadingText]="loadingText()"
	[notFoundText]="notFoundText()"
	[options]="options()"
	[placeholder]="placeholder()"
	[searchable]="true"
	[selectedLabel]="selectedLabel()"
	[(value)]="value"
	(blurred)="closePanel()"
	(changed)="update()"
	(cleared)="onCleared()"
	(searched)="onSearched($event)"
	className="autocomplete"
	downIcon="icon-looking-glass"
	optionTestClass="autocomplete-item"
	testId="autocomplete"
	upIcon="icon-looking-glass"
	variant="integrated"
/>
